@if (profileField$ | async; as profileField) {
  <sh-form-number-input
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [control]="control$ | async"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [title]="disabledMessageKey | translate"
    >
    <ng-content></ng-content
    ></sh-form-number-input>
  }
